import { get, post, put, } from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";

export const addAdvertToFavorite = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.addAdvertToFavorite}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data, config);
};
export const addAdvertToAlarm = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.addAdvertToAlarm}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data, config);
};
export const updateAlarm = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.updateAlarmItem}`;
  const config = headers.content_type.application_json;
  return put<DataResponse<any>>(url, data, config);
};
export const getAdvertDetails = async (advertId: string | null): Promise<DataResponse<any>> => {
  const url = `${endpoints.getAdvertDetails}/${advertId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};
export const getAdvertDetailsByNo = async (advertNo: number): Promise<DataResponse<any>> => {
  const url = `${endpoints.getAdvertDetails}/${advertNo}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};
export const getNearbyPlaces = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.getNearbyPlaces}?latitude=${data.lat}&longitude=${data.lng}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};
export const getCategoryTreeFindId = async (categoryId: string): Promise<DataResponse<any>> => {
  const url = `${endpoints.getCategoryTreeFindId}/?Id=${categoryId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};
export const getCategoryTreeById = async (
  filter?: any
): Promise<DataResponse<any>> => {
  // const query = filter?CreateUrlFilter(filter):null;

  const url = `${endpoints.getCategoryTreeById}?FilterUrl=${filter || ""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getCategoryFilter = async (
  filter?: any
): Promise<DataResponse<any>> => {
  // const query = filter?CreateUrlFilter(filter):null;

  const url = `${endpoints.getCategoryTreeByFilter}?FilterUrl=${filter || ""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};


export const getCategoryById = async (
  filter?: any
): Promise<DataResponse<any>> => {
  const url = `${endpoints.getCategoryById}/${filter || ""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};


export const sendMessage = async (data: any, isUseForm: boolean = false): Promise<DataResponse<any>> => {
  const url = `${endpoints.sendMessage}`;
  const config = headers?.content_type.multipart_form_data;
  return post<DataResponse<any>>(url, data, config);
};

